﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RestService {
    constructor(private http: HttpClient) { }

    base: string = '.';

    getAll(endPoint: string): Observable<any[]> {
        return this.http.get<any[]>(this.base + endPoint);
    }

    get(endPoint: string): Observable<any> {
        return this.http.get<any>(this.base + endPoint);
    }

    getParam(clave: string): Observable<any> {
        return this.http.get<any>(this.base + '/rest-api/public/parametro/' + clave);
    }

    post(endPoint: string, object: any): Observable<any> {
        return this.http.post<any>(this.base + endPoint, object);
    }

}
